import React, { useState } from 'react'
import { Menu, MenuItem, MenuList, Paper } from '@mui/material'
import { MoreButton } from 'common/Button/MoreButton'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import OrbitSession from 'hooks/useCookies'
import { DataRolloverRows } from 'types/api/faber/subscription.type'

import { FaberCDRDialog, ManualRolloverDialog } from '../dialogs'

const FaberRolloverActionMenu = ({ row }: FaberRolloverActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }
  const role = OrbitSession.get('role')

  const [CDRDialog, setCDRDialog] = useState(false)
  const [manualRolloverDialogOpen, setManualRolloverDialoOpen] = useState(false)

  const handleDialogOpen = () => {
    setCDRDialog(true)
  }

  const handleDialogClose = () => {
    setCDRDialog(false)
  }

  return (
    <>
      <MoreButton onClick={handleMenuOpen} />
      <Paper>
        <MenuList dense>
          <Menu
            id='action-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem onClick={() => handleDialogOpen()}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                View Details
              </TextColorFontBody>
            </MenuItem>
            {role === 'opsowner' ? (
              <MenuItem onClick={() => setManualRolloverDialoOpen(true)}>
                <TextColorFontBody
                  sx={{
                    color: circlesOrbitColorPalette.neutrals[600],
                    fontSize: '12px'
                  }}
                >
                  Manual Rollover
                </TextColorFontBody>
              </MenuItem>
            ) : null}
            {/* TO DO: Remove when confirmed dont need this  */}
            {/* <FaberDataRolloverDialog
              handleDialogClose={handleDialogClose}
              rolloverDialog={CDRDialog}
              handleMenuClose={handleMenuClose}
              row={row}
            /> */}
            <FaberCDRDialog
              handleDialogClose={handleDialogClose}
              rolloverDialog={CDRDialog}
              handleMenuClose={handleMenuClose}
              row={row}
            />
            <ManualRolloverDialog
              handleDialogClose={() => setManualRolloverDialoOpen(false)}
              manualRolloverDialog={manualRolloverDialogOpen}
              handleMenuClose={handleMenuClose}
              row={row}
            />
          </Menu>
        </MenuList>
      </Paper>
    </>
  )
}

interface FaberRolloverActionMenuProps {
  row: DataRolloverRows
}

export default FaberRolloverActionMenu
